var exports = {
  "Rd": "PreviewLabel__FYUGZW",
  "pS": "FeedbackLinkWrapper__URxZOU",
  "Mj": "SidebarDivider__R8jjcp",
};

module.exports = exports;
